import React from 'react';
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Dialog,
    DialogContent,
    Container, Grid, Typography, Button
    ,Box
} from '@mui/material';
import Divider from "@mui/material/Divider";
import {mappingBaseInterface} from '../../api/definition';

function SamplePreview(props: any){
    return (
        <Dialog open={props.open}
                maxWidth='xl'
                fullWidth
        >
            <Container maxWidth='xl' sx={{mt:2, mb:2}}>
                <Grid container spacing={1}>
                    <Grid item lg={10} md={10} sm={10} xs={10}>
                        <Typography variant='h6'>
                            샘플양식 미리보기
                        </Typography>
                    </Grid>
                    <Grid item lg={2} md={2} sm={2} xs={2} sx={{textAlign:'right'}}>
                        <Button
                            size="small"
                            variant='contained'
                            onClick={props.handleUploadSamplePreviewClose}
                            sx={{mb:1}}
                        >
                            닫기
                        </Button>
                    </Grid>
                </Grid>
                <Divider />
                <Box sx={{mt:2, ml:3}}>
                    <Typography>※ 업로드할 파일의 타이틀은 반드시 아래의 타이틀과 동일하게 입력하셔야 합니다</Typography>
                    <Typography>※ 항목을 더 추가하시고 싶으실 경우에는 “프로세스 설정“ 에서 매핑설정에서 “Input“ 항목을 추가해주세요</Typography>
                </Box>
               <DialogContent>
                   {!Array.isArray(props.previewList) ? (
                            <Box sx={{
                              backgroundColor: '#f7f7f7',
                              border: '1px solid #ccc',
                              borderRadius: 2,
                              p: 2,
                              whiteSpace: 'pre-wrap',
                              overflowX: 'auto',

                            }}>
                              {JSON.stringify(props.previewList, null, 2)}
                            </Box>
                   )
                       : (
                           <TableContainer component={Paper}>
                                <Table size="small">
                                 <TableHead>
                                    <TableRow>
                                      {props.previewList.map((col:mappingBaseInterface, index:number) => (
                                        <TableCell key={index} sx={{
                                          backgroundColor: '#f5f5f5',
                                          border: '1px solid #ccc',
                                          fontWeight: 'bold',
                                          minWidth: 100,
                                          textAlign: 'center'}}>{col.input_name}</TableCell>
                                      ))}
                                    </TableRow>
                                  </TableHead>
                                  <TableBody>
                                    {[...Array(5)].map((_, rowIndex) => (
                                      <TableRow key={rowIndex}>
                                        {props.previewList.map((col:mappingBaseInterface, colIndex:number) => (
                                          <TableCell key={colIndex} sx={{
                                                    border: '1px solid #eee',
                                                    height: 40,
                                                    minWidth: 100
                                                  }}></TableCell>
                                        ))}
                                      </TableRow>
                                    ))}
                                  </TableBody>
                                </Table>
                              </TableContainer>
                       )
                   }
                </DialogContent>

            </Container>
        </Dialog>
    );
}

export default SamplePreview;